import { useNavigate } from "react-router-dom";
import Modal from "../../../hooks/Modal";

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<any>;
};

export default function CheckYourEmail({ isOpen, setIsOpen }: Props) {
  const navigate = useNavigate();
  const handleClose = () => {
    setIsOpen(false);
    navigate("/");
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size="lg" title="">
      <div className="md:w-[600px] w-full flex flex-col gap-8 p-4 justify-center items-center">
        <h3 className="heading3">Thank you for registering</h3>
        <h5 className="heading5">
          Signup Succeeded, please check your email, to verify your account and
          start using Hailling Trades
        </h5>
        <button className="btn-primary" onClick={handleClose}>
          Close
        </button>
      </div>
    </Modal>
  );
}
